import React, {Children, useState} from "react"
import {Trans, useTranslation} from "react-i18next";
import {Box, Typography} from "@mui/material"

import {useSnackbar} from "../../../../contexts";
import {IAIToolsProps, sortVendorData} from "../../home.helper";
import {aiToolsInfoCardStyles, marginBottom} from "./aiToolsInfoCard-helpers";
import {VendorCard} from "../vendorCard/VendorCard";

import TransMsg from "../../transMessage";
import {RedirectDialog} from "../../../../components";


export const AIToolsInfoCard = (props: IAIToolsProps) => {
    const {data} = props
    const {t} = useTranslation();
    const {showSnackbar} = useSnackbar();
    const vendorListData = data?.length > 0 ? sortVendorData(data) : []
    const [openRedirectDialog, setOpenRedirectDialog] = useState<boolean>(false)
    const [selectedVendor, setSelectedVendor] = useState<any>({})

    const onSelectVendorItem: (itemData: any) => void = (itemData: any): void => {
        // @ts-ignore
        amplitude.logEvent(`user clicked ${itemData?.title} vendor`)
        setSelectedVendor(itemData)

        // handle redirection modal if checked already
        const getCheckedVendors = localStorage.getItem("checkedVendors")
        const checkedVendorsList: any[] = getCheckedVendors ? JSON.parse(getCheckedVendors) : []
        const isModalShown = checkedVendorsList?.includes(itemData?.vendorId)
        setOpenRedirectDialog(!isModalShown)
        if (isModalShown && itemData?.redirectURL) {
            const url = itemData?.redirectURL
            if (url) {
                window.open(`https://${url}`, '_blank', 'noopener,noreferrer');
            } else {
                showSnackbar("redirect uri is not available!", "error")
            }
        }
    }

    return (
        <Box sx={{...aiToolsInfoCardStyles.container, backgroundColor: '#ECEFF4'}}>
            <Typography
                sx={aiToolsInfoCardStyles.sectionHeading}>
                Join the Exploration –<br/> Test AI Tools Now
            </Typography>

            {/*Vendor Logos */}
            <Box sx={aiToolsInfoCardStyles.vendorLogoList}>
                {vendorListData?.length > 0 && Children.toArray(vendorListData.map((item: any, index: number) => {
                    const logoSvg = item?.card_logo ? require(`../../../../assets/images/svgs/${item?.card_logo}`) : ""
                    return (
                        <Box sx={aiToolsInfoCardStyles.vendorLogo} key={index + 1}>
                            <Box sx={{py: "18px"}}>
                                <img src={logoSvg} style={{width: "100%", height: "40px"}}
                                     alt={`vendor-item-${index}`}/>
                            </Box>
                        </Box>
                    )
                }))}
            </Box>

            <Typography variant="body2" sx={{...aiToolsInfoCardStyles.text, fontWeight:400, fontSize:'22px'}}>
                Early GA may be difficult to detect with<br /> traditional OCTs. AI can assist by detecting<br /> subtle biomarkers before they become<br /> obvious.
            </Typography>

            {/* Vendor Cards */}
            <Box sx={{maxWidth: "600px", mx: 'auto', mb: marginBottom}}>
                {vendorListData?.length > 0 && Children.toArray(vendorListData.map((item: any, index: number) => {
                    const logoSecondaryImg = item?.card_logo ? require(`../../../../assets/images/other/home/${item?.name}_secondary_card_image.png`) : "";
                    return (
                        <VendorCard item={item} logoImage={logoSecondaryImg} index={index}
                                    onSelectVendorItem={onSelectVendorItem}/>
                    )
                }))}
            </Box>
            <Box display={"flex"} justifyContent={"center"}>
                <Box >
                    <Typography sx={{
                        ...aiToolsInfoCardStyles.text,
                        fontSize: "15px",
                        fontStyle: "italic",
                        pb: 6,
                        fontWeight: "300",
                    }}>
                        <Trans i18nKey={t(TransMsg.JOIN_AI_FOOTER_DESCRIPTION)} components={{br: <br/>}}/>
                    </Typography>
                </Box>
            </Box>

            <RedirectDialog
                showDialog={openRedirectDialog}
                vendorItem={selectedVendor}
                onCloseRedirectDialog={() => setOpenRedirectDialog(false)}/>
        </Box>
    )
}